import { Link } from 'react-router-dom';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import '@/pages/timeline/sections/timeline/timelineSections/certificate/style.css'
export default function NocVerificationPending(props: any) {
    const { timeline, common } = useLocalTranslation();
    return (
        <div className='commonMainCon'>
            <p className='commonp1 mb-[8px] text-[#FD3535] font-bold'>{timeline.certificateSection.nocVerificationPending.h1}</p>
            <p className='commonp1 mb-[15px]'>
                {timeline.certificateSection.nocVerificationPending.p1}
                <Link
                    className='ml-[5px] text-[#0173e7] underline'
                    to="#">{common.statusText.contactSupport}</Link>
            </p>
            <button
                disabled
                className='commonb1 commonb1_bg_grey cursor-not-allowed'>
                {common.statusText.claimYourCertificate}
            </button>
        </div>
    );
};

